/**
 * Renders the Clubs dropdown menu in the navigation bar with ClubLink components
 */
import React, { useEffect, useState } from "react";
import { CSSTransition } from "react-transition-group";
import ArrowIcon from "./ArrowIcon";
import { Link } from "react-router-dom";
import ClubLink from "./ClubLink";
import { useQuery } from "@tanstack/react-query";
import { useDropdown } from "./DropdownContext";

const DropdownMenu = (id) => {
  const { openDropdown, setOpenDropdown } = useDropdown();
  const isOpen = openDropdown === id;

  const toggleDropdown = () => {
    setOpenDropdown(isOpen ? null : id);
  };

  const handleLinkClick = () => {
    setOpenDropdown(null);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        event.target.closest(".dropdown-menu") === null &&
        !event.target.closest(".relative")
      ) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [setOpenDropdown]);

  const { isLoading, error, data } = useQuery({
    staleTime: Infinity,
    queryKey: ["clubs"],
    queryFn: () =>
      fetch(`${process.env.REACT_APP_BUIHA_API_URL}/club/all/`).then((res) =>
        res.json()
      ),
  });

  if (isLoading || error)
    return (
      <li className="relative group">
        <Link
          to="#"
          className="dark:hover:text-dark-5 hover:text-buiha-red hover:text-gray-800 py-2 px-4 lg:text-2xl text-xl md:flex hidden items-center font-medium"
          onClick={(e) => {
            e.preventDefault();
            toggleDropdown();
          }}
        >
          {" "}
          {/* Header */}
          Clubs
        </Link>
      </li>
    );

  // if (error) return 'An error has occurred: ' + error.message;

  data && data.sort((a, b) => (a.name > b.name ? 1 : -1));

  return (
    <li
      className="relative group"
      onMouseEnter={toggleDropdown}
      onMouseLeave={() => setOpenDropdown(null)}
    >
      <Link
        to="#"
        className="dark:hover:text-dark-5 hover:text-buiha-red py-2 px-4 lg:text-2xl text-xl md:flex hidden items-center font-medium"
        key={id}
        onClick={(e) => {
          e.preventDefault();
          toggleDropdown();
        }}
      >
        {/* Header */}
        Clubs
        <ArrowIcon />
      </Link>

      {/* Dropdown menu */}
      <CSSTransition
        in={isOpen}
        timeout={200}
        classNames="dropdown"
        unmountOnExit
      >
        <div
          className={`border-2 border-light-3 dark:border-dark-3 dropdown-menu absolute bg-light-1 dark:bg-dark-4 ml-3 py-1 w-auto rounded-b-lg z-20`}
        >
          {/* Content */}

          <Link
            to="/clubs"
            className="w-full block px-2 text-sm hover-slide flex-row flex items-center"
            onClick={handleLinkClick}
          >
            <img src="/buihamini.png" alt="BUIHA Logo" className="w-6 h-6 mr-1" />
            BUIHA Clubs
          </Link>
          <div className="mx-2 border-t-2 border-light-6 dark:border-dark-6 w-88 my-1"></div>

          {/* North and South Club Links */}
          <div className="flex flex-row-reverse justify-start items-start">
            <div className="flex flex-col justify-center items-start">
              {data ? (
                data.map((club) =>
                  // If club.status == active, then show the club
                  club.status === "Active" && club.location === "North" ? (
                    <ClubLink
                      to={"/club/" + club.stub}
                      altText={club.name}
                      clubName={club.name}
                      imgSrc={club.logo.md}
                      handleLinkClick={handleLinkClick}
                    />
                  ) : (
                    <></>
                  )
                )
              ) : (
                <></>
              )}
            </div>
            <div className="flex flex-col justify-center items-start">
              {data ? (
                data.map((club) =>
                  // If club.status == active, then show the club
                  club.status === "Active" && club.location === "South" ? (
                    <ClubLink
                      to={"/club/" + club.stub}
                      altText={club.name}
                      clubName={club.name}
                      imgSrc={club.logo.md}
                      handleLinkClick={handleLinkClick}
                    />
                  ) : (
                    <></>
                  )
                )
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </CSSTransition>
    </li>
  );
};

export default DropdownMenu;
